import {
  Box,
  Button,
  Checkbox,
  FileInput,
  Flex,
  Group,
  Table,
  Text,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconDownload,
  IconUpload,
  IconX,
} from "@tabler/icons-react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
  UpdatefilexcelCollectiopnFrame,
  UpdatefilexcelSpecialProduct,
} from "../../../../api/ApiCollection";
import {
  UpdatefilexcelProduct,
  UpdatefilexcelProductPrice,
} from "../../../../api/ApiProduct";
import { UpdatefilexcelProductDeal } from "../../../../api/ApiProductDeal";
import { UpdatefilexcelRedirect } from "../../../../api/ApiRedirect";
import { UpdatefilexcelComment } from "../../../../api/ApiUserComment";
import { UpdatefilexcelReview } from "../../../../api/apiUserReview";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_URL } from "../../../../config";
import { API_ROUTE } from "../../../../const/apiRoute";
import ButtonClose from "../../../../common/ButtonClose/ButtonClose";
type Props = {
  location: {
    pathname: string;
  };
  typeImport?: string; // Thêm typeImport nếu cần thiết
};
const ModalUpdateExcelProduct = ({ location, typeImport }: Props) => {
  const [visible, { close, open }] = useDisclosure(false);
  console.log("location", location);
  const entity =
    location.pathname === "/product-manager/product-list"
      ? {
        Options: {
          UpdatePrice: false,
          UpdateMarketPrice: false,
          UpdateInventoryQuantity: false,
          UpdateVisibility: false,
          UpdateVAT: false,
          UpdateWarrantyInfo: false,
          UpdatePromotionInfo: false,
          UpdateItemName: false,
          UpdateItemModel: false,
          UpdateSKU: false,
          UpdateItemCondition: false,
          UpdateCssClassStatus: false,
          UpdateItemSpecification: false,
          UpdateItemDescription: false,
          UpdateItemSpecificationTable: false,
          UpdateUrl: false,
          UpdateMetaTilte: false,
          UpdateMetaDescription: false,
          UpdateMetaKeyword: false,
          UpdateCssStyle: false,
          UpdatePriceRangeDv: false,
          UpdateNote: false,
        },
        FormFile: null,
      }
      : {
        FormFile: null,
      };

  const handleCreateProvince = async (dataSubmit: DataProvince) => {
    const formData = new FormData();

    if (dataSubmit.FormFile) {
      formData.append("FormFile", dataSubmit.FormFile); // thêm file vào FormData
    } else {
      NotificationExtension.Fails("Vui lòng chọn một file để cập nhật."); // Thêm thông báo nếu không có file
      return;
    }

    // Format Options data theo cách API mong đợi
    if (dataSubmit.Options) {
      Object.keys(dataSubmit.Options).forEach((key) => {
        const value =
          dataSubmit.Options![key as keyof typeof dataSubmit.Options];
        formData.append(`Options[${key}]`, value.toString());
      });
    }

    open(); // Mở loading overlay
    console.log("dataSubmit", dataSubmit);
    console.log("FormData entries:");
    // Debug FormData entries
    const entries = Array.from(formData.entries());
    entries.forEach(([key, value]) => {
      console.log(key + ": " + value);
    });

    let response;
    if (
      //cập nhật sản phẩm
      location.pathname === "/product-manager/product-list" &&
      typeImport !== "productPrice"
    ) {
      response = await UpdatefilexcelProduct(formData); // Gọi hàm cập nhật file excel với FormData
    } else if (
      location.pathname === "/product-manager/product-list" &&
      typeImport === "productPrice"
    ) {
      //cập nhật giá sản phẩm
      response = await UpdatefilexcelProduct(formData); // Gọi hàm cập nhật file excel SEO với FormData
    } else if (location.pathname === "/product-seo-upload-excel") {
      response = await UpdatefilexcelProductPrice(formData); // Gọi hàm cập nhật file excel SEO với FormData
    } else if (location.pathname === "/url-redirect") {
      response = await UpdatefilexcelRedirect(formData); // Gọi hàm cập nhật file excel cho URL redirect với FormData
    } else if (location.pathname === "/user-review") {
      response = await UpdatefilexcelReview(formData); // Gọi hàm cập nhật file excel cho user review với FormData
    } else if (location.pathname === "/user-comment") {
      response = await UpdatefilexcelComment(formData); // Gọi hàm cập nhật file excel cho user review với FormData
    } else if (location.pathname === "/product-manager/collection") {
      response = await UpdatefilexcelSpecialProduct(formData); // Gọi hàm cập nhật file excel cho sản phẩm đặc biệt với FormData
    } else if (location.pathname === "/marketing-manager/product-deal") {
      response = await UpdatefilexcelProductDeal(formData); // Gọi hàm cập nhật file excel cho deal sản phẩm với FormData
    } else if (location.pathname === "/marketing-manager/deal-shocking-price") {
      response = await UpdatefilexcelProductDeal({ ...dataSubmit, Type: 1 });
    } else if (location.pathname === "/product-manager/collection-frame") {
      response = await UpdatefilexcelCollectiopnFrame(formData); // Gọi hàm cập nhật file excel cho quản lý khung với FormData
    } else {
      return;
    }
    console.log("response", response);
    if (response?.success) {
      modals.closeAll();
      NotificationExtension.Success("Cập nhật thành công"); // Thêm thông báo thành công
    } else {
      NotificationExtension.Fails("Cập nhật thất bại"); // Thêm thông báo thất bại
    }

    close(); // Đóng loading overlay
  };

  const handleDownloadTemplate = async () => {
    open();
    let urlApi = "";
    if (
      location.pathname === "/product-manager/product-list" &&
      typeImport !== "productPrice"
    ) {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_UPDATE_ITEM; // URL API cho sản phẩm
    } else if (
      location.pathname === "/product-manager/product-list" &&
      typeImport === "productPrice"
    ) {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_UPDATE_ITEM_PRICE; // URL API cho SEO sản phẩm
    } else if (location.pathname === "/product-seo-upload-excel") {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_UPDATE_ITEM_SEO; // URL API cho SEO sản phẩm
    } else if (location.pathname === "/url-redirect") {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_URL_REDIRECT; // URL API cho URL redirect
    } else if (location.pathname === "/user-review") {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_USER_REVIEW; // URL API cho user review
    } else if (location.pathname === "/user-comment") {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_USER_COMMENT; // URL API cho user comment
    } else if (
      location.pathname === "/product-manager/collection" ||
      location.pathname === "/product-manager/collection-frame"
    ) {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_CATEGORY_SPECIAL_PRODUCT; // URL API cho collection
    } else if (
      location.pathname === "/marketing-manager/product-deal" ||
      location.pathname === "/marketing-manager/deal-shocking-price"
    ) {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_DEAL; // URL API cho deal sản phẩm
    } else if (location.pathname === "/product-manager/category") {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_CATEGORY;
    } else if (location.pathname === "/article-manager/article-list") {
      urlApi = API_ROUTE.IMPORT_TEMPLATE_ARTICLEV2;
    } else {
      NotificationExtension.Fails("Không có template để tải xuống");
      close();
      return;
    }
    try {
      await fetch(`${BASE_API_URL}${urlApi}`, {
        method: "GET",
      })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error("Failed to fetch the resource");
          }
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          let filename = "Template_Mau.xlsx";
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export excel thành công !");
        })
        .catch((error) => {
          console.error("Error:", error);
          NotificationExtension.Fails("Export excel thất bại !");
        });
    } catch (error) {
      console.log("Error downloading template:", error);
      NotificationExtension.Fails("Tải file mẫu thất bại");
    } finally {
      close(); // Đóng loading overlay sau khi tải xong
    }
  };

  const form = useForm<DataProvince>({
    initialValues: {
      ...entity,
    },
    validate: {
      FormFile: (value) => (value ? null : "Vui lòng chọn một file"),
    },
  });

  return (
    <Box
      className="flex-none"
      component="form"
      miw={700}
      maw={700}
      mx="auto"
      onSubmit={form.onSubmit((e: DataProvince) => {
        handleCreateProvince(e);
      })}
    >
      <LoadingOverlayCustom visible={visible} />
      <Group justify="flex-end" mt="sm">
        <Button
          variant="outline"
          color="green"
          leftSection={<IconDownload size={18} />}
          onClick={() => handleDownloadTemplate()}
        >
          Tải File Mẫu
        </Button>
      </Group>
      <Group grow wrap="nowrap">
        <FileInput
          label="Nhập File"
          description="Upload Excel files (.xls, .xlsx)"
          placeholder="Select a file"
          accept=".xls,.xlsx"
          {...form.getInputProps("FormFile")}
          rightSection={<IconUpload />}
        />
      </Group>
      {location.pathname === "/product-manager/product-list" &&
        typeImport !== "productPrice" && (
          <Flex gap={"md"} w={"100%"}>
            <Flex direction={"column"} gap={"md"} mt={"md"} w={"50%"}>
              {/*<Checkbox
                label="Cập nhật giá"
                {...form.getInputProps("Options.UpdatePrice", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật giá thị trường"
                {...form.getInputProps("Options.UpdateMarketPrice", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật số lượng kho hàng"
                {...form.getInputProps("Options.UpdateInventoryQuantity", {
                  type: "checkbox",
                })}
              />*/}
              <Checkbox
                label="Cập nhật hiển thị"
                {...form.getInputProps("Options.UpdateVisibility", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật VAT"
                {...form.getInputProps("Options.UpdateVAT", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật thông tin bảo hành"
                {...form.getInputProps("Options.UpdateWarrantyInfo", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật thông tin khuyến mãi"
                {...form.getInputProps("Options.UpdatePromotionInfo", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật tên sản phẩm"
                {...form.getInputProps("Options.UpdateItemName", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật model sản phẩm"
                {...form.getInputProps("Options.UpdateItemModel", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật mã hàng sản phẩm"
                {...form.getInputProps("Options.UpdateSKU", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật tình trạng sản phẩm (cũ/mới)"
                {...form.getInputProps("Options.UpdateItemCondition", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật thông số sản phẩm"
                {...form.getInputProps("Options.UpdateItemSpecification", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật ghi chú"
                {...form.getInputProps("Options.UpdateNote", {
                  type: "checkbox",
                })}
              />
            </Flex>
            <Flex direction={"column"} gap={"md"} mt={"md"} w={"50%"}>
              <Checkbox
                label="Cập nhật CSS Class"
                {...form.getInputProps("Options.UpdateCssClassStatus", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật CSS Style"
                {...form.getInputProps("Options.UpdateCssStyle", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật mô tả sản phẩm"
                {...form.getInputProps("Options.UpdateItemDescription", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật bảng thông số sản phẩm"
                {...form.getInputProps("Options.UpdateItemSpecificationTable", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật Url sản phẩm"
                {...form.getInputProps("Options.UpdateUrl", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật Meta Tilte sản phẩm"
                {...form.getInputProps("Options.UpdateMetaTilte", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật Meta Description sản phẩm"
                {...form.getInputProps("Options.UpdateMetaDescription", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật Meta Keyword sản phẩm"
                {...form.getInputProps("Options.UpdateMetaKeyword", {
                  type: "checkbox",
                })}
              />
              <Checkbox
                label="Cập nhật Giá HSSV/Khoảng từ - đến"
                {...form.getInputProps("Options.UpdatePriceRangeDv", {
                  type: "checkbox",
                })}
              />
            </Flex>
          </Flex>
        )}

      {location.pathname === "/product-manager/product-list" &&
        typeImport === "productPrice" && (
          <Box mt="md">
            <Table
              striped
              highlightOnHover
              withColumnBorders
              verticalSpacing="md"
              horizontalSpacing="lg"
            >
              <thead style={{ backgroundColor: "#f1f3f5" }}>
                <tr>
                  <th style={{ textAlign: "center", fontWeight: "bold" }}>
                    Cột Excel
                  </th>
                  <th style={{ textAlign: "center", fontWeight: "bold" }}>
                    Nội dung
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ textAlign: "center" }}>ID Sản phẩm Web</td>
                  <td style={{ textAlign: "center" }}>A</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Mã kho (SKU)</td>
                  <td style={{ textAlign: "center" }}>B</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Giá bán khuyến mại</td>
                  <td style={{ textAlign: "center" }}>C</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Giá thêm 1</td>
                  <td style={{ textAlign: "center" }}>D</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Giá thêm 2</td>
                  <td style={{ textAlign: "center" }}>E</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Giá thêm 3</td>
                  <td style={{ textAlign: "center" }}>F</td>
                </tr>
              </tbody>
            </Table>
          </Box>
        )}

      {location.pathname === "/product-seo-upload-excel" && (
        <Box mt="md">
          <Table
            striped
            highlightOnHover
            withColumnBorders
            verticalSpacing="md"
            horizontalSpacing="lg"
          >
            <thead style={{ backgroundColor: "#f1f3f5" }}>
              <tr>
                <th style={{ textAlign: "center", fontWeight: "bold" }}>
                  Cột Excel
                </th>
                <th style={{ textAlign: "center", fontWeight: "bold" }}>
                  Nội dung
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>A</td>
                <td style={{ textAlign: "center" }}>ID Sản phẩm Web</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>B</td>
                <td style={{ textAlign: "center" }}>Mã kho (SKU)</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>C</td>
                <td style={{ textAlign: "center" }}>Thẻ Meta Title</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>D</td>
                <td style={{ textAlign: "center" }}>Thẻ Meta Keyword</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>E</td>
                <td style={{ textAlign: "center" }}>Thẻ Meta Description</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>F</td>
                <td style={{ textAlign: "center" }}>Tên rút gọn</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>G</td>
                <td style={{ textAlign: "center" }}>Url Index</td>
              </tr>
            </tbody>
          </Table>
        </Box>
      )}

      {location.pathname === "/url-redirect" && (
        <Text mt={"md"} size="md">
          -{" "}
          <strong
            style={{
              color: "red",
              fontWeight: "bold",
            }}
          >
            Cảnh báo:
          </strong>{" "}
          Nên hạn chế số lượng url redirect tại website vì quá nhiều url sẽ ảnh
          hưởng tới tốc độ của web (do mỗi link truy cập sẽ bị kiểm tra xem có
          phải là link redirect hay không).
        </Text>
      )}
      <Group
        justify="center"
        mt="xs"
        p="5px 0"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="submit"
          color="#3598dc"
          loading={visible}
          leftSection={<IconCheck size={18} />}
        >
          Cập Nhật
        </Button>
        <ButtonClose />
      </Group>
    </Box>
  );
};

type DataProvince = {
  //   FormFile: any; // Thay đổi kiểu thành File | null
  Options?: {
    UpdatePrice: boolean;
    UpdateMarketPrice: boolean;
    UpdateInventoryQuantity: boolean;
    UpdateVisibility: boolean;
    UpdateVAT: boolean;
    UpdateWarrantyInfo: boolean;
    UpdatePromotionInfo: boolean;
    UpdateItemName: boolean;
    UpdateItemModel: boolean;
    UpdateSKU: boolean;
    UpdateItemCondition: boolean;
    UpdateCssClassStatus: boolean;
    UpdateItemSpecification: boolean;
    UpdateItemDescription: boolean;
    UpdateItemSpecificationTable: boolean;
    UpdateUrl: boolean;
    UpdateMetaTilte: boolean;
    UpdateMetaDescription: boolean;
    UpdateMetaKeyword: boolean;
    UpdateCssStyle: boolean;
    UpdatePriceRangeDv: boolean;
  };
  FormFile: File | null; // File được upload
};

export default ModalUpdateExcelProduct;
